import React from 'react'

const MoviesSuggestion = () => {
  return (
    <div>MoviesSuggestion</div>
  )
}

export default MoviesSuggestion